// © 2025 Ananda Kumar. All rights reserved.
// Unauthorized copying of this file, via any medium, is strictly prohibited.

import { Component, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationService } from '../../../services/configuration.service';
import { TenantService } from '../../../services/tenant.service';
import { Router } from '@angular/router';
import { EventService } from '../../../services/event.service';

@Component({
  selector: 'app-invite-card',
  standalone: false,
  templateUrl: './invite-card.component.html',
  styleUrl: './invite-card.component.css'
})
export class InviteCardComponent {
  couples: string[] = [];
  eventOverview: any;
  detailsLoaded = false;
  coverImageUrl: string | null = null;
  configurationLoaded = false;
  tenantType: string | null = null;
  eventDate: string | null = null;
  eventTitle: string | null = null;
  eventLocation: string | null = null;
  eventCount: number = 0;

  @Output() rsvpClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private http: HttpClient,
    private configurationService: ConfigurationService,
    public tenantService: TenantService,
    private router: Router,
    private eventService: EventService
  ) { }

  ngOnInit() {
    // this.tenantService.tenantType$.subscribe((tenantType) => {
      this.tenantType = this.tenantService.getTenantType();
    // });

    this.eventService.getEvents()
      .subscribe((data: any) => {
        this.eventCount = data.length;
      });
    // Load configuration for overview, cover image and event details
    this.configurationService.getConfiguration().subscribe({
      next: (config) => {
        // Parse eventOverview if present (might be stringified)
        let eo: any = null;
        if (config) {
          if (config['eventOverview']) {
            try {
              eo = typeof config['eventOverview'] === 'string' ? JSON.parse(config['eventOverview']) : config['eventOverview'];
            } catch {
              eo = config['eventOverview'];
            }
          }

          // If no eventOverview in config, attempt to use top-level fields
          if (!eo) {
            eo = {
              couple: config['couple'] ?? null,
              eventDate: config['eventDate'] ?? null,
              whatsappChannelUrl: config['whatsappChannelUrl'] ?? config['whatsappChannel'] ?? null
            };
          }

          this.couples = eo?.partners ?? [];
          this.eventOverview = eo;

          this.coverImageUrl = config.coverImageUrl || null;
          this.eventDate = config['eventDate'] || eo?.eventDate || null;
          this.eventLocation = config['eventVenue'] || null;
          this.eventTitle = config['eventTitle'] || null;
        }
        this.detailsLoaded = true;
        this.configurationLoaded = true;
      },
      error: (error) => {
        console.error('Failed to load configuration:', error);
        this.coverImageUrl = null; // Use default image
        this.configurationLoaded = true;
        this.detailsLoaded = true;
      }
    });
  }

  onRsvpClick() {
    this.rsvpClick.emit();
  }

  onViewInviteClick() {
    this.router.navigateByUrl(this.tenantService.getTenantPrefixedPath('/event/invitation')[0]);
  }

  get eventDateExtract() {
    if (this.eventDate) {
      const date = new Date(this.eventDate);
      return date.getDate();
    }
    return null;
  }

  get eventMonth() {
    if (this.eventDate) {
      const date = new Date(this.eventDate);
      return date.toLocaleDateString('en-US', { month: 'long' });
    }
    return null;
  }

  get eventTime() {
    if (this.eventDate) {
      const date = new Date(this.eventDate);
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: false });
    }
    return null;
  }

  get eventTimeSuffix() {
    if (this.eventDate) {
      const date = new Date(this.eventDate);
      const hours = date.getHours();
      return hours >= 12 ? 'pm' : 'am';
    }
    return null;
  }

  get eventDateExtractSuffix() {
    if (this.eventDate) {
      const date = new Date(this.eventDate);
      return this.getOrdinalSuffix(date.getDate());
    }
    return null;
  }

  private getOrdinalSuffix(day: number): string {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }
}